module.exports = __webpack_public_path__ + "media/img/event/sponsor/bosworth-independent-college-logo-70128a3122938ca864805876a73159d1.png";